"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFCPreview = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var FileIcon_1 = require("components/FileIcon");
var react_redux_1 = require("react-redux");
var automaticFileConversion_1 = require("utils/dispatchers/automaticFileConversion");
var PreviewMessage_1 = require("views/FilesPreviewView/components/PreviewMessage");
var enhanceIFCPreview = (0, recompose_1.compose)(recompose_1.pure);
function get_url_params(revision, revisions) {
    if (revisions === void 0) { revisions = []; }
    if (revisions.length > 0) {
        return revisions
            .reduce(function (acc, x) {
            if (x.preview) {
                acc.push("uuid[]=".concat(x.preview.uuid));
            }
            return acc;
        }, [])
            .join('&');
    }
    return "uuid[]=".concat(revision.preview && revision.preview.uuid);
}
exports.IFCPreview = enhanceIFCPreview(function (props) {
    var _a;
    var dispatch = (0, react_redux_1.useDispatch)();
    var automaticFileConversion = (0, react_redux_1.useSelector)(function (state) { return ({
        automaticFileConversion: state.files.automaticFileConversion
    }); }).automaticFileConversion;
    var _b = (0, automaticFileConversion_1.mapDispatchToProps)(dispatch), setFilePreview = _b.setFilePreview, setConversionErrorToast = _b.setConversionErrorToast;
    React.useEffect(function () {
        if (props.revision.uuid === automaticFileConversion.revisionUuid) {
            setFilePreview(automaticFileConversion.preview.uuid, automaticFileConversion.revisionUuid, automaticFileConversion.preview.status);
            if (automaticFileConversion.error) {
                setFilePreview('empty', automaticFileConversion.revisionUuid, 'FAILED');
                setConversionErrorToast(props.revision.name);
            }
            else
                setFilePreview(automaticFileConversion.preview.uuid, automaticFileConversion.revisionUuid, automaticFileConversion.preview.status);
        }
    }, [automaticFileConversion]);
    if (props.revision.preview) {
        if (props.revision.preview.status === 'PROCESSED') {
            return (React.createElement("iframe", { src: "".concat(__APIBASEURL__, "api/files/preview/?").concat(get_url_params(props.revision, props.revisions)), className: 'iframe-style ifc-view' }));
        }
        else if (props.revision.preview.status === 'PROCESSING') {
            return (React.createElement(PreviewMessage_1.default, { modelImageIcon: (0, FileIcon_1.typeToIconAndTextMap)('IFC').icon, messageKey: "filesPreview/preview/ifc/waitUntilModalHasBeenExported", iconClassName: "sok-icon-3d-orange" }));
        }
    }
    return ((_a = props.revision.preview) === null || _a === void 0 ? void 0 : _a.status) === 'FAILED' ? (React.createElement(PreviewMessage_1.default, { modelImageIcon: (0, FileIcon_1.typeToIconAndTextMap)('IFC').icon, messageKey: "filesPreview/preview/ifc/conversionFailed", iconClassName: "sok-icon-3d-red", onConvertClick: function () { return props.revision && props.convert(props.revision); } })) : (React.createElement(PreviewMessage_1.default, { modelImageIcon: (0, FileIcon_1.typeToIconAndTextMap)('IFC').icon, messageKey: "filesPreview/preview/ifc/pleaseUploadIfcModelToBimsync", iconClassName: "sok-icon-3d-pink", onConvertClick: function () { return props.revision && props.convert(props.revision); } }));
});
exports.default = exports.IFCPreview;
